<template>
  <!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
  <svg
    id="Component_166_3"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    :viewBox="showText ? '0 0 27 45' : '0 0 27 23.5'"
    style="enable-background:new 0 0 33 45;"
    xml:space="preserve"
    overflow="visible"
  >
    <path
      id="Icon_simple-microsoftexcel"
      class="st0"
      d="M25.4,2.9h-8v1.5h2.4v2.3h-2.4v0.7h2.4v2.3h-2.4v0.8h2.4v2.2h-2.4v0.9h2.4v2.2h-2.4v0.9h2.4V19h-2.4v1.6h8c0.1,0,0.2-0.2,0.3-0.4c0.1-0.2,0.1-0.4,0.1-0.6V3.1c0-0.1,0-0.2-0.1-0.2C25.6,2.9,25.5,2.9,25.4,2.9zM24.4,19h-3.8v-2.2h3.8V19L24.4,19z M24.4,15.9h-3.8v-2.2h3.8V15.9z M24.4,12.8h-3.8v-2.2h3.8C24.4,10.6,24.4,12.8,24.4,12.8zM24.4,9.8h-3.8V7.4h3.8V9.8C24.4,9.8,24.4,9.8,24.4,9.8z M24.4,6.7h-3.8V4.4h3.8V6.7L24.4,6.7z M2,2.5V21l14.1,2.4V0L2,2.5L2,2.5zM10.3,16.5c-0.1-0.1-0.3-0.8-0.8-1.9c-0.4-1.1-0.7-1.7-0.8-1.9h0l-1.5,3.6l-2-0.1l2.4-4.5L5.4,7.2l2.1-0.1l1.4,3.5h0L10.4,7l2.1-0.1L10,11.7l2.6,4.9L10.3,16.5L10.3,16.5z"
    />
    <text
      v-show="showText"
      transform="matrix(1 0 0 1 0 41)"
      class="st0 st1 st2"
    >Excel</text>
  </svg>
</template>

<script lang="ts">
export default {
  name: 'ExcelIcon',
  props: {
    showText: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.st0 {
  fill:main.$npGray;
}
.st1 {
  font-family:main.$fontPrimary;
}
.st2 {
  font-size:14px;
}
</style>
